module.exports = __webpack_public_path__ + "static/img/wa03.aecf39e7.png";